import { jsxs as p, jsx as i } from "react/jsx-runtime";
import { forwardRef as $, useRef as v, useEffect as C } from "react";
import { g as x } from "../checkbox/BaseCheckbox-BGkrjof6.mjs";
const N = (a) => {
  let e = a;
  for (; e; ) {
    const t = window.getComputedStyle(e);
    if (t.backgroundColor !== "rgba(0, 0, 0, 0)" && t.backgroundColor !== "transparent")
      return t.backgroundColor;
    e = e.parentElement;
  }
  return "transparent";
}, g = $(
  ({
    className: a = "",
    id: e,
    labelClass: t = "",
    type: h = "text",
    valid: n,
    lightBackground: d = !1,
    label: s,
    errorMessage: r,
    ...b
  }, w) => {
    const o = x(), c = x(e), f = d === "white", u = !r && n, m = !!r || n === !1, l = v(null);
    return C(() => {
      l.current && (l.current.style.backgroundColor = N(l.current));
    }, []), /* @__PURE__ */ p("div", { className: a, children: [
      /* @__PURE__ */ i(
        "div",
        {
          className: `rds-textfield
            ${d ? "rds-light" : ""}
            ${f ? "rds-white" : ""}`,
          children: /* @__PURE__ */ p(
            "label",
            {
              htmlFor: c,
              className: `rds-textfield-label ${t} ${d ? "rds-light" : ""} ${f ? "rds-white" : ""}`,
              "data-valid": u,
              children: [
                /* @__PURE__ */ i(
                  "input",
                  {
                    ref: w,
                    id: c,
                    className: `rds-textfield-input ${m ? "rds-textfield-input--error" : ""}`,
                    type: h,
                    placeholder: s,
                    "aria-invalid": m,
                    "aria-describedby": r ? o : void 0,
                    "data-valid": u,
                    ...b
                  }
                ),
                /* @__PURE__ */ i("span", { ref: l, className: "rds-textfield-label-text", children: s })
              ]
            }
          )
        }
      ),
      r && /* @__PURE__ */ i(
        "span",
        {
          id: o,
          className: `rds-textfield rds-textfield--error-text ${d ? "rds-light" : ""}`,
          children: r
        }
      )
    ] });
  }
);
g.displayName = "TextField";
export {
  g as T
};
